import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'weavix-shared/services/navigation.service';
import { AccountService } from 'weavix-shared/services/account.service';
import { Facility } from 'weavix-shared/models/facility.model';

@Injectable({
    providedIn: 'root',
})
export class FacilitySwitchService {
    constructor(
        private readonly accountService: AccountService,
        private readonly router: Router,
        private readonly navigationService: NavigationService,
    ) {
    }
    async switchFacility(facility: Facility, isNavigator: boolean = true): Promise<void> {
        await this.accountService.switchAccount(facility.accountId, false);
        if (isNavigator) {
            // regex: capture the url part after the facility ID, e.g. /a/my-account/f/62e001c1-a6e8-466b-af9b-42733234150d/people/live-look
            const routePath = this.router.url.match(/\/a\/[^/]+\/f\/[^/]+\/(.+)/)?.[1];
            if (!routePath) return;
            const similarUrl = `/f/${facility.id}/${routePath}`;
            if (this.navigationService.isUrlAvailable(similarUrl)) {
                await this.router.navigateByUrl(similarUrl);
            } else {
                await this.router.navigateByUrl(this.navigationService.getFirstAvailableItemUrl());
            }
        }
    }
}
